import React from 'react';
import propTypes from 'prop-types';

function MovieListItem(props) {
  return (
    <div className="movie">
      <h2 className="movie-title">{props.movie.title} </h2>
      <img src={props.movie.backdrop_path} />
      <p className="movie-overview">{props.movie.overview}</p>
      <footer>
        <button>More info</button>
      </footer>
    </div>
  );
}

MovieListItem.defaultProps = {
  title2: 'Unkown'
};

MovieListItem.propTypes = {
  movie: propTypes.shape({
    title: propTypes.string.isRequired
  }).isRequired,
  title2: propTypes.string
};
export default MovieListItem;



// WEBPACK FOOTER //
// ./src/components/MovieListItem.js